import requestService from '@/services/requester'

const RESOURCE_NAME = '/users'
const API_URL = requestService.API_BASE_URL + RESOURCE_NAME

let userService = {
    async getAll (parameters) {
        let endpoint = `${API_URL}`
        let response = await requestService.retrieve(endpoint, parameters)

        if (response.data !== null) {
            return response
        } else {
            throw new Error(response.data.message)
        }
    },

    async update (data) {
        let endpoint = `${API_URL}/`
        return requestService.update(endpoint, data)
    },

    async delete (parameters) {
        let endpoint = `${API_URL}/delete`
        return requestService.delete(endpoint, parameters)
    },

    async restore (parameters) {
        let endpoint = `${API_URL}/restore/`
        return requestService.update(endpoint, parameters)
    },

    async create (parameters) {
        let endpoint = `${API_URL}/create`
        let response = await requestService.create(endpoint, parameters)

        if (response.data !== null) {
            let affectedRows = response.data.user_id
            if (affectedRows > 0) {
                return response
            } else {
                throw new Error(response.data.message)
            }
        } else {
            throw new Error(response.data.message)
        }
    }
}

export default userService
